import DataProvider from '@kakadu-dev/base-frontend-helpers/helpers/DataProvider';
import RequestActionHelper from '@kakadu-dev/base-frontend-helpers/helpers/Redux/RequestActionHelper';
import { default as BaseSagaHelper } from '@kakadu-dev/base-frontend-helpers/helpers/Redux/SagasHelper';
import { all, call, put, select } from 'redux-saga/effects';
import { ProductsApi } from "../../modules/products/api";
import { StateSelector } from "../../modules/selectors";
/**
 * Base components sage helper
 */

class SagasHelper extends BaseSagaHelper {
  /**
   * Add customer id to request body
   *
   * @param {SearchQuery} searchQuery
   *
   * @return {IterableIterator<SelectEffect>}
   */
  static *beforeAddCustomerId(searchQuery) {
    if (!searchQuery.getBody().customerId) {
      const customer = yield select(StateSelector.user.getUser);
      const customerId = customer?.result?.id;

      if (customerId) {
        searchQuery.addBody({
          customerId
        }, true);
      }
    }
  }
  /**
   * Default saga list action
   *
   * @param {object} action
   * @param {function} api
   * @param {function} beforeResponse
   * @param {function} afterResponse
   *
   * @return {undefined}
   */


  static *defaultList(action, api, beforeResponse, afterResponse) {
    yield SagasHelper.defaultAction(action, api, DataProvider.handleResponseList, beforeResponse, afterResponse);
  }
  /**
   * Default saga action
   *
   * @param {object} action
   * @param {function} api
   * @param {function} beforeResponse
   * @param {function} afterResponse
   *
   * @return {undefined}
   */


  static *action(...params) {
    const [action, ...otherParams] = params;
    const {
      payload
    } = action;
    const searchQuery = DataProvider.getSearchQueryBody(payload);
    const nextAction = { ...action,
      payload: searchQuery
    };
    yield SagasHelper.defaultAction(nextAction, ...otherParams);
  }
  /**
   * Default saga lists action
   *
   * @param {Object} action
   * @param {Array.<SearchQuery>} action.payload
   * @param {Function} api
   * @param {Function} responseHandler
   * @param {Function} beforeResponse
   * @param {Function} afterResponse
   *
   * @return {undefined}
   */


  static *listsAction(action, api, responseHandler, beforeResponse, afterResponse) {
    const {
      payload: queries,
      type
    } = action;
    const {
      request,
      success,
      error
    } = RequestActionHelper.getAllActions(type);
    const searchQuery = DataProvider.getSearchQuery(queries?.[0]);
    const callList = {};

    try {
      yield put(request(queries));

      if (typeof beforeResponse === 'function') {
        yield beforeResponse(queries);
      }

      queries.forEach((query, idx) => {
        callList[idx] = call(ProductsApi.list, queries[idx]);
      });
      const responses = yield all(callList);

      if (!responseHandler) {
        const list = [];
        Object.values(responses).forEach(response => {
          const category = {};
          category.category = response?.result?.list?.[0]?.categories?.[0]?.category ?? {};
          category.products = response?.result?.list ?? [];
          list.push(category);
        });
        yield put(success({
          list
        }, queries));
      } else {
        yield put(success(responseHandler(responses), queries));
      }

      if (typeof afterResponse === 'function') {
        yield afterResponse(responses, queries);
      }

      searchQuery.runSuccessCallback(responses);
    } catch (e) {
      yield put(error(searchQuery.addReduxRequestParams({
        error: e
      })));
      searchQuery.runErrorCallback(e);
    }

    searchQuery.runCallback();
  }

}

export default SagasHelper;